<template>
  <jf-layout>
    <template slot="head">
      <el-select size="small" clearable @change="search" v-model="params.type" style="margin-right:10px">
        <el-option v-for="item in typeList" :key="item.id" :value="item.value" :label="item.dictLabel"></el-option>
      </el-select>
      <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button size="small" type="primary" icon="el-icon-circle-plus" v-if="isAuth('platform-config:serviceprotocol:save')" @click="add">新增</el-button>
      <el-button size="small" type="danger" icon="el-icon-delete" v-if="isAuth('platform-config:serviceprotocol:delete')" :disabled="!selectList.length" @click="remove(null)">删除</el-button>
    </template>

    <el-table slot="body" border :data="list" v-loading="loading" @selection-change="selectChange">
      <el-table-column align="center" type="selection" width="50" />
      <el-table-column align="center" prop="title" label="协议名称" />
      <el-table-column align="center" label="协议类型">
        <span slot-scope="{row}">
          {{typeList.find(item=>{
            return item.value ===row.type
          }).dictLabel}}
        </span>
      </el-table-column>
      <el-table-column align="center" prop="createDate" label="创建时间" />
      <el-table-column align="center" prop="realName" label="操作人" />
      <el-table-column align="center" label="操作">
        <template slot-scope="{row}">
          <el-button size="mini" icon="el-icon-edit" v-if="isAuth('platform-config:serviceprotocol:update')" @click="edit(row)">编辑</el-button>
          <el-button size="mini" icon="el-icon-delete" v-if="isAuth('platform-config:serviceprotocol:delete')" @click="remove(row)" type="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <jf-page slot="foot" @change="getList" :page.sync="params.page" :limit="params.limit" :total="total" />
    <Form :show.sync="show" :row="row" @add="search" @edit="getList" />
  </jf-layout>
</template>

<script>
import Form from "./form";
export default {
  components: { Form },
  data() {
    return {
      show: false,
      params: {
        page: 1,
        limit: 10,
        type: "",
      },
      list: [],
      loading: false,
      row: {},
      total: 0,
      selectList: [],
      typeList: [],
    };
  },
  created() {
    this.getType();
    this.getList();
  },
  methods: {
    /* 获取协议字典类型 */
    getType() {
      this.$get("/platform-admin/dict/data/page", {
        page: 1,
        limit: 99,
        dictTypeId: "1407985006663565313",
      }).then((res) => {
        if (res && res.code === 0) {
          this.typeList = res.data.list;
          this.typeList.map((item) => {
            this.$set(item, "value", Number(item.dictValue));
          });
        }
      });
    },
    search() {
      this.params.page = 1;
      this.getList();
    },
    async getList() {
      this.loading = true;
      var res = await this.$get(
        "/platform-config/serviceprotocol/page",
        this.params
      );
      this.loading = false;
      if (res && res.code === 0) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
    },
    selectChange(list) {
      this.selectList = list;
    },
    add() {
      this.row = {};
      this.show = true;
    },
    edit(row) {
      this.row = row;
      this.show = true;
    },
    remove(row) {
      this.$confirm("确认删除选择的数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          if (row) {
            var ids = [row.id];
          } else {
            var ids = this.selectList.map((item) => {
              return item.id;
            });
            console.log(ids);
          }
          var res = await this.$del("/platform-config/serviceprotocol", ids);

          if (res && res.code === 0) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          }
        })
        .catch(() => {});
    },
  },
};
</script>

